module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("禁用 eslint")]), _vm._v(" "), _c('p', [_vm._v("并不推荐禁用"), _c('code', [_vm._v("eslint")]), _vm._v(", 编码规范可以一定程序上保证代码质量。但是如果你确实想禁用，可以删除"), _c('code', [_vm._v("build/webpack.base.conf.js")]), _vm._v("里的相关代码。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("preLoaders: [\n  {\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/\\.vue$/")]), _vm._v(",\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loader")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'eslint'")]), _vm._v(",\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("include")]), _vm._v(": [\n     path.join(projectRoot, "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src'")]), _vm._v(")\n   ],\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("exclude")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/node_modules/")]), _vm._v("\n  },\n  {\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/\\.js$/")]), _vm._v(",\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loader")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'eslint'")]), _vm._v(",\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("include")]), _vm._v(": [\n     path.join(projectRoot, "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src'")]), _vm._v(")\n   ],\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("exclude")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/node_modules/")]), _vm._v("\n  }\n]\n")])]), _vm._v(" "), _c('p', [_vm._v("如果你只是想禁用对某一文件的检测，那么可以在"), _c('code', [_vm._v(".eslintignore")]), _vm._v("里添加规则。")]), _vm._v(" "), _c('p', [_vm._v("如果你是想禁止某一行的检测，那么可以使用"), _c('code', [_vm._v("// eslint-disable-line")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("更加灵活的使用参考 "), _c('a', {
    attrs: {
      "href": "http://eslint.org/docs/user-guide/configuring#disabling-rules-with-inline-comments"
    }
  }, [_vm._v("eslint文档")]), _vm._v("。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8dd28292", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-8dd28292"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vue-loader-disable-eslint-289.vue
// module id = 2387
// module chunks = 212